import FeatureEnabledDashboard from 'portal/src/layouts/base/FeatureEnabledDashboard';

import { isBillAutomationViewEnabled } from './billAutomationEnabled';

export default function BillAutomationDashboard({
  slug,
  disabledSlug,
}: {
  slug: string;
  disabledSlug?: string;
}): React.ReactElement {
  return (
    <FeatureEnabledDashboard
      slug={slug}
      disabledSlug={disabledSlug}
      isFeatureEnabled={isBillAutomationViewEnabled}
    />
  );
}
